import { FILTER_TYPES } from 'components/FilterPod';

const filters = [
  {
    title: 'نام و نام‌خانوادگی',
    label: 'نام و نام‌خانوادگی',
    keyName: 'fullName',
    id: 2150,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
  {
    title: 'تلفن همراه',
    label: 'تلفن همراه',
    keyName: 'phoneNumber',
    id: 2151,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {
      englishNumber: true,
    },
  },
  {
    title: 'نام کاربری',
    label: 'نام کاربری',
    keyName: 'userName',
    id: 2153,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {
      englishNumber: true,
    },
  },
  {
    title: 'شناسه کاربر',
    label: 'شناسه کاربر',
    keyName: 'userId',
    id: 2148,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {
      englishNumber: true,
    },
  },
  {
    title: 'شناسه',
    label: 'شناسه',
    keyName: 'id',
    id: 2147,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {
      englishNumber: true,
    },
  },
];

export default filters;
